export default __webpack_public_path__ + "static/media/btn_audiocomics_active.79b8197f.png";